<template>
  <div>
    <!-- kadoMenu area -->
    <div class="div-kadoMenu">
      <div class="div-kadoMenu-button" @click="kadoMenuDispSwitch">
        <span class="div-kadoMenu-line div-kadoMenu-line01" :class="{'div-kadoMenu-button-line01':kadoMenuDispFlg}"></span>
        <span class="div-kadoMenu-line div-kadoMenu-line02" :class="{'div-kadoMenu-button-line02':kadoMenuDispFlg}"></span>
        <span class="div-kadoMenu-line div-kadoMenu-line03" :class="{'div-kadoMenu-button-line03':kadoMenuDispFlg}"></span>
      </div>
      <transition>
        <div v-show="kadoMenuDispFlg" class="div-kadoMenu-List">
          <ul>
          <li class="li-inuse"><router-link to="/">Home</router-link></li>
          <li class="li-inuse"><router-link to="/tag">Tag</router-link></li>
          <li class="li-inuse"><router-link to="/auth/signin">Sign in</router-link></li>
          <li class="li-inuse"><router-link to="/auth/signupstart">Sign Up Start</router-link></li>
          <li class="li-inuse"><router-link to="/auth/signupfix">Sign Up Fix</router-link></li>
          <li class="li-inuse"><router-link to="/auth/passwdchange">Password Change</router-link></li>
          <!--<li><router-link to="/auth/passwdresetstart">Passowrd Reset Start</router-link>-->
          <li class="li-nouse"><router-link to="/">Passowrd Reset Start</router-link>
          <!--<li><router-link to="/auth/passwdresetfix">Password Reset Fix</router-link></li>-->
          <li class="li-nouse"><router-link to="/">Password Reset Fix</router-link></li>
          <!--<li><router-link to="/auth/emailchangestart">Email Change Start</router-link></li>-->
          <li class="li-nouse"><router-link to="/">Email Change Start</router-link></li>
          <!--<li><router-link to="/auth/emailchangefix">Email Change Fix</router-link></li>-->
          <li class="li-nouse"><router-link to="/">Email Change Fix</router-link></li>
          <li class="li-inuse"><router-link to="/auth/attributeget">Attribute Get</router-link></li>
          <!--<li><router-link to="/auth/attributechange">Attribute Change</router-link></li>-->
          <li class="li-nouse"><router-link to="/">Attribute Change</router-link></li>
          <li class="li-close" @click="kadoMenuDispSwitch">[ close ]</li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KadoMenu',

  data: function () {
    return {
      kadoMenuDispFlg: false
    }
  },

  methods: {
    /* =================================================================================
     * kadoMenuDispSwitch
     *   角っこメニューの表示を切替
     * ============================================================================== */
    kadoMenuDispSwitch () {
      this.kadoMenuDispFlg = !this.kadoMenuDispFlg
    }
  }
}
</script>

<style scoped lang="scss">
$BASE_COLOR: #055555;
.v-enter-active, .v-leave-active {
  transition: opacity .3s
}
.v-enter, .v-leave-to {
  opacity: 0
}
.div-kadoMenu-button {
  position: absolute;
  top: 0;
  right: 0;
  width: 38px;
  height: 38px;
  background-color: $BASE_COLOR;
  cursor: pointer;
  z-index: 12;
}
.div-kadoMenu-line {
  position: absolute;
  top: 0;
  left: 7px;
  width: 25px;
  height: 2px;
  background-color: #fff;
  text-align: center;
}
.div-kadoMenu-line01 {
  top: 8px;
  transition: 0.4s ease;
}
.div-kadoMenu-line02 {
  top: 18px;
  transition: 0.4s ease;
}
.div-kadoMenu-line03 {
  top: 28px;
  transition: 0.4s ease;
}
.div-kadoMenu-button-line01 {
  transform: translateY(10px) rotate(-45deg);
  transition: 0.4s ease;
}
.div-kadoMenu-button-line02 {
  transition: 0.4s ease;
  opacity: 0;
}
.div-kadoMenu-button-line03 {
  transform: translateY(-10px) rotate(45deg);
  transition: 0.4s ease;
}
.div-kadoMenu-List {
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 0;
  right: 0;
  width: 22em;
  z-index: 11;
  border:1px dotted #ccb;
  ul {
    padding: 0;
    margin: 45px 0.5em 0.5em 0.5em;
    background-color: rgba(245,245,245,0.8);
    border-block-style: solid;
    border-block-color: #ccb;
    border-width: 0 1px;
  }
  li {
    margin: 0;
    padding: 0 2em;
    line-height: 3em;
    list-style: none;
    &:first-child {
      border-top: 1px dotted #ccb;
      border-bottom: 1px dotted #ccb;
    }
    + li {
      border-bottom: 1px dotted #ccb;
    }
  }
  .li-inuse {
    a {
      text-decoration: none;
      color: #333;
    }
    &:hover {
      color: #fff;
      background-color: $BASE_COLOR;
      a {
        color: #fff;
      }
    }
  }
  .li-nouse {
    a {
      text-decoration: #333 line-through;
      color: #aaa;
    }
    &:hover {
      a {
        cursor: not-allowed;
      }
    }
  }
  .li-close {
    display: none;
  }
}
@media screen and (max-width: 559px) {
  .div-kadoMenu-List {
    width: 100%;
    li {
      padding: 0 3em;
      line-height: 2.25em;
    }
    .li-close {
      display: block;
      line-height: 1.5em;
      background-color: $BASE_COLOR;
      color: #fff;
    }
  }
}
</style>
